// extracted by mini-css-extract-plugin
export default {"approvedSolarComponent":"approved-solar-component_approvedSolarComponent__iGU7D"};